$(function () {
  var checkExist = setInterval(function () {
    if ($(".bsub-widget__plans-container").length) {
      if ($(selectors.subIntervalOptionTitle).length === 0) {
        clearInterval(checkExist);
        return;
      }
      setInitial();
      linkVariants();
      clearInterval(checkExist);
    }
  }, 100);
  const selectors = {
    subIntervalOptionTitle: ".option_title:contains('Subscription Term')",
    optionParent: ".swatch",
    swatchElement: ".swatch-element",
    optionTextElement: "label",
    bsubParent: ".widget__wrapper",
    bsubText: ".bsub-widget__text",
    bsubClickable: "",
  };
  function setInitial() {
    const $activeOptions = $(selectors.subIntervalOptionTitle)
      .closest(selectors.optionParent)
      .find("input:checked+.swatch-element");
    const subTermText = $activeOptions
      .find(selectors.optionTextElement)
      .clone() //clone the element
      .children() //select all the children
      .remove() //remove all the children
      .end() //again go back to selected element
      .text()
      .trim();
    const matchingSubTrigger = $(selectors.bsubText).filter(function () {
      //match case insensitive subterm text
      var reg = new RegExp(subTermText, "i");
      return reg.test($(this).text());
    });
    if (matchingSubTrigger.length > 0) {
      $(matchingSubTrigger[0]).trigger("click");
    }
  }
  function linkVariants() {
    $(selectors.subIntervalOptionTitle)
      .closest(selectors.optionParent)
      .find(selectors.swatchElement)
      .each(function () {
        var $this = $(this);
        const subTermText = $this
          .find(selectors.optionTextElement)
          .clone() //clone the element
          .children() //select all the children
          .remove() //remove all the children
          .end() //again go back to selected element
          .text()
          .trim();
        $this.on("click", () => {
          const matchingSubTrigger = $(selectors.bsubText).filter(function () {
            //match case insensitive subterm text
            var reg = new RegExp(subTermText, "i");
            return reg.test($(this).text());
          });
          if (matchingSubTrigger.length > 0) {
            $(matchingSubTrigger[0]).trigger("click");
          }
        });
      });
  }
});
